import * as cheerio from "cheerio";

export const findContentTitle = (htmlContent: string): string => {
    const $ = cheerio.load(htmlContent);
    return $("h1").first().text();
};